import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import ContainerWrapper from '../../../../components/ContainerWrapper/container-wrapper.component';
import Header from '../../../../components/Header';
import Title from '../../../../components/title/title.component';
import ConteudoMinistradoWrapper from './components/conteudo-ministrado-wrapper/conteudo-ministrado-wrapper.component';
import StudentSkillWrapper from './components/student-skill-wrapper/student-skill-wrapper.component';
import './lancamento-aula-edit.styles.scss';
import useLancamentoAulaEdit from './use-lancamento-aula-edit.hook';
import useBackClassroomPage from '../../hooks/use-back-classroom-page.hook';

export default function LancamentoAulaEdit() {
  const { backClassroomPage } = useBackClassroomPage();
  useLancamentoAulaEdit();

  return (
    <>
      <Header />
      <ContainerWrapper hasHeader>
        <div className={'lancamento-aula-edit__title-button'}>
          <Title title={'Editar Aula Lançada'} />
          <Button
            onClick={backClassroomPage}
            className="button-second"
            style={{
              width: '40px',
              height: '40px'
            }}
            icon={<CloseOutlined />}
          />
        </div>

        <ConteudoMinistradoWrapper />
        <StudentSkillWrapper />

      </ContainerWrapper>
    </>
  );
}

